import { render, staticRenderFns } from "./PromotionList.vue?vue&type=template&id=5f37bb89&scoped=true&lang=pug&"
import script from "./PromotionList.vue?vue&type=script&lang=js&"
export * from "./PromotionList.vue?vue&type=script&lang=js&"
import style0 from "./PromotionList.vue?vue&type=style&index=0&id=5f37bb89&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f37bb89",
  null
  
)

export default component.exports